import React, { useState, useEffect } from 'react';
import ReportTitleBanner from './ReportTitleBanner';
import Table from '../Common/table';
import axios from '../httpServices/httpService';
import api from '../config'
import swal from 'sweetalert';
import auth from '../httpServices/authService';
import validation from '../utill/validation';
import _, { cloneDeep } from 'lodash';
import joi from 'joi'
import Loading from './../utill/LoadingComponent';
import date from '../utill/dateTime';
import EquipmentSelection from '../Common/equipmentSelection';
import DetailedProductionTable from '../utill/detailedProductionTable';
import AnalysisDetailedProduction from './AnalysisDetailedProduction';
import '../App.css';
import DetailedProductionTable1 from '../utill/detailedProductionTable1';
import { ToastContainer, toast } from 'react-toastify';

const DetailedProduction1 = ({ handleDownloadTableToExcel, equips, equipGroups, reasons, qualityReason ,fromDateLimit}) => {
    const [productionData, setProductionData] = useState([])
    const [cacheData, setCacheData] = useState([])
    const yesterday = (() => { const d = new Date(); d.setDate(d.getDate() - 1); return d; })();
    const [inputData, setInputData] = useState({ From: yesterday, Till: yesterday })
    const [selectedEquipGroupOption, setSelectedEquipGroupOption] = useState([]);
    const [selectedEquipOption, setSelectedEquipOption] = useState([]);
    const [equip, SetEquips] = useState([])
    const [errors, setErrors] = useState({});
    const [index, setIndex] = useState(0);
    const [querySuccess, setQuerySuccess] = useState(false);
    const [processEmail, setProcessEmail] = useState(false);
    const [sortColumn, setSortColumn] = useState({ path: 'Date', order: 'asc' })
    const [analyseState, setAnalyseState] = useState(false)


    const [selectedEquipGroupOption1, setSelectedEquipGroupOption1] = useState([]);
    const [inputData1, setInputData1] = useState({});
    const [inputData2, setInputData2] = useState({});
    const [selectedEquipOption1, setSelectedEquipOption1] = useState([]);
    const [equip1, SetEquips1] = useState([])
    const [shiftOption1, setShiftOption1] = useState([
        { label: 'Shift1', value: 'Shift1', checked: false },
        { label: 'Shift2', value: 'Shift2', checked: false },
        { label: 'Shift3', value: 'Shift3', checked: false },
        { label: 'Shift4', value: 'Shift4', checked: false }])

    const schema = {
        From: joi.date().required().label('From Date'),
        UserId: joi.string(),
        Till: joi.date().required().label('Till Date'),
        Equips: joi.array()
    }

    const GetDailyFrames = (FromDate, TillDate) => {
        let frame = []
        let from = new Date(new Date(FromDate).setHours(0, 0, 0, 0));
        let till = new Date(new Date(TillDate).setHours(0, 0, 0, 0));
        // from.setHours(from.getHours()-5);
        // from.setMinutes(from.getMinutes()-30);

        // till.setHours(till.getHours()-5);
        // till.setMinutes(till.getMinutes()-30);
        while (from <= till) {
            let obj = { From: new Date(from) };
            from.setHours(23, 59, 59, 999)
            obj.Till = new Date(from);
            frame.push(obj);
            from.setDate(from.getDate() + 1)
            from.setHours(0, 0, 0, 0);


        }
        return frame
    }








    const ProductionReportSchema = [
        { path: 'Date', label: 'Date', content: (obj) => <label>{date.getDateFormat(obj.From)}</label> },
        { path: 'Shift', label: 'Shift' },
        { path: 'EquipmentGroup', label: 'EquipmentGroup' },
        { path: 'Equipment', label: 'Equipment' },
        { path: 'Cycles', label: 'Cycles', content: (obj) => <label>{obj.Cycles ? obj.Cycles : '-'}</label> },
        { path: 'AvailableTime', label: 'Runtime', content: (obj) => <label>{obj.AvailableTime ? obj.AvailableTime : '-'}</label> },

    ]

    const handleOnChnageAnalysis = (e) => {
        const data = { ...inputData1 };
        const input2 = { ...inputData2 }
        if (e.currentTarget.name == 'Shift') {
            const options = [...shiftOption1];
            if (e.currentTarget.value && (e.currentTarget.value == 'All')) {
                options.forEach(one => one.checked = e.currentTarget.checked);
            } else {
                options.forEach(one => {
                    if (one.value == e.currentTarget.value) {
                        one.checked = e.currentTarget.checked
                    }
                });
            }
            data[e.currentTarget.name] = options.filter(one => one.checked);
            setShiftOption1(options);
        }
        else {
            if (e.currentTarget.type == 'date') {

                if ((e.currentTarget.name == "From")) {
                    let oldFrom = new Date(inputData.From)
                    oldFrom.setHours(0, 0, 0, 0);
                    let oldFrom1 = new Date(e.currentTarget.value)
                    oldFrom1.setHours(0, 0, 0, 0);
                    if (oldFrom > oldFrom1) {
                        swal("from date can not out of range", { dangerMode: true })
                        return
                    }
                }
                if ((e.currentTarget.name == "Till")) {
                    let oldTill = new Date(inputData.Till)
                    oldTill.setHours(23, 59, 59, 999);
                    let oldTill1 = new Date(e.currentTarget.value)
                    oldTill1.setHours(23, 59, 59, 999);
                    if (oldTill < oldTill1) {
                        swal("till date can not out of range", { dangerMode: true })
                        return
                    }

                }
                data[e.currentTarget.name] = e.currentTarget.value
            } else {
                data[e.currentTarget.name] = e.currentTarget.value
            }

        }

        if (e.currentTarget.name == "ReportType") {
            let obj = {}
            const shifts = [...shiftOption1]
            obj[e.currentTarget.name] = e.currentTarget.value;
            obj["Periodicity"] = input2.Periodicity;
            setInputData1(obj);
            setInputData2(obj);
            shifts.forEach(shift => {
                shift.checked = false
            })
            setShiftOption1(shifts)
            setSelectedEquipOption1([]);
            setSelectedEquipGroupOption1([])
        } else {
            setInputData1(data);
        }

    }
    const handleOnChange = (e) => {
        if (e.currentTarget.type === 'date') {
            inputData[e.currentTarget.name] = new Date(e.currentTarget.value);
            inputData1[e.currentTarget.name] = new Date(e.currentTarget.value);
        }
        else {
            inputData[e.currentTarget.name] = e.currentTarget.value;
        }
        setInputData(inputData);
        setInputData1(inputData1);
        setErrors({})
    }
    const getEquipsForReport = () => {
        let equipArr = []
        equips.forEach((one) => {
            selectedEquipOption.forEach((option) => {
                if (one._id == option.value) {
                    equipArr.push(one);
                }
            })
        })
        return equipArr;
    }
    const handleOnSubmit = async (inputData) => {
        productionData.splice(0, productionData.length);
        setIndex(0)
        // consol(inputData)
        const errors = validation.validate(inputData, schema);
        // consol(errors)
        setErrors(errors || {});
        if (errors) return;
        setProcessEmail(false)
        setQuerySuccess(true)
        const user = auth.getCurrentUser();
        inputData.UserId = user._id
        
            if(new Date(inputData.From) <= new Date(inputData.Till)){
            }else{
            setQuerySuccess(false);
           
            return  toast.success('From date should be Less Than Till date', {
              position: 'bottom-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: '#babbbb', // Set your desired background color
                color: 'white',     // Set your desired text color
              },
            });
          }
      
        let equipForReport = getEquipsForReport()
        for (let i = 0; i < equipForReport.length; i++) {
            try {
                let list = GetDailyFrames(new Date(inputData.From), new Date(inputData.Till));
                for (let frame = 0; frame < list.length; frame++) {
                    let obj = { From: list[frame].From, Till: list[frame].Till, Equips: [equipForReport[i]] }
                    let result = await axios.post(api.dataEntryUrl + 'DetailedProduction', obj)
                    if (result.data !== null && result.data !== undefined) {
                        if (result.data.length > 0) {

                            result.data.forEach((one) => {
                                productionData.push(one);
                            })
                            setProductionData(productionData)
                            setCacheData([...productionData])
                            let idx = i + 1

                            setIndex(idx)

                        }
                    }
                    else {
                        setQuerySuccess(false)
                    }
                }





            }
            catch (err) {

                if (err.message && err.message == "Network Error") {
                    let alert = await swal({
                        title: "Network Error",
                        text: `You want to restore connection and fetch data from server`,
                        icon: "warning",
                        buttons: true,
                        dangerMode: true
                    })
                    if (alert) {
                        continue;
                    } else {
                        // consol(err)
                        setQuerySuccess(false)
                        break;
                    }

                    // swal({
                    //     title: "Network Error",
                    //     text: `You want  restore connection and  fetch data from server`,
                    //     icon: "warning",
                    //     buttons: true,
                    //     dangerMode: true
                    // }).then(async (willDelete) => {

                    //     // if (willDelete) {
                    //     //     try {

                    //     //         let list = GetDailyFrames(new Date(inputData.From), new Date(inputData.Till));
                    //     //         for (let frame = 0; frame < list.length; frame++) {
                    //     //             let obj = { From: list[frame].From, Till: list[frame].Till, Equips: [equipForReport[i]] }
                    //     //             let result = await axios.post(api.dataEntryUrl + 'DetailedProduction', obj)
                    //     //             if (result.data !== null && result.data !== undefined) {
                    //     //                 if (result.data.length > 0) {

                    //     //                     result.data.forEach((one) => {
                    //     //                         productionData.push(one);
                    //     //                     })
                    //     //                     setProductionData(productionData)
                    //     //                     setCacheData([...productionData])
                    //     //                     let idx = i + 1

                    //     //                     setIndex(idx)

                    //     //                 }
                    //     //             }
                    //     //             else {
                    //     //                 setQuerySuccess(false)
                    //     //             }
                    //     //         }





                    //     //     }
                    //     //     catch (err) {
                    //     //         throw err;
                    //     //     }

                    //     // }
                    //     // else {

                    //     //     setQuerySuccess(false)

                    //     // }
                    // });
                } else {
                      toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: 'red', // Set your desired background color
            color: 'white',     // Set your desired text color
          },
        });
                    // consol(err)
                    setQuerySuccess(false)
                    break;
                }

            }
            // }

        }
        setQuerySuccess(false)


    }

    // const handleOnSendEmail = async (inputData) => {
    //     // productionData.splice(0, productionData.length);
    //     // setIndex(0)
    //     // consol(inputData)
    //     const errors = validation.validate(inputData, schema);
    //     // consol(errors)
    //     setErrors(errors || {});
    //     if (errors) return;
    //     setProcessEmail(true)
    //     setQuerySuccess(true)
    //     const user = auth.getCurrentUser();
    //     inputData.UserId = user._id
    //     let equipForReport = getEquipsForReport()
    //     try {
    //         let obj = { From: new Date(inputData.From),UserId:user._id, Till: new Date(inputData.Till), Equips: equipForReport,SendEmail:true }
    //         let result = await axios.post(api.dataEntryUrl + 'DetailedProductionSendEmail', obj)
    //         swal(`Email Send Successfully`);
    //         // setQuerySuccess(false)
    //     }
    //     catch (err) {

    //         if (err.message && err.message == "Network Error") {
    //             setProcessEmail(false)
    //             setQuerySuccess(false)
    //             let alert = await swal({
    //                 title: "Network Error",
    //                 text: `You want to restore connection and fetch data from server`,
    //                 icon: "warning",
    //                 buttons: true,
    //                 dangerMode: true
    //             })
    //         } else {
    //             swal(`${err}`);
    //             // consol(err)
    //             setProcessEmail(false)
    //             setQuerySuccess(false)

    //         }

    //     }
    //     setProcessEmail(false)
    //     setQuerySuccess(false)


    // }


    const handleSort = (sortColumn) => {
        if (productionData.length > 0) {
            const sorted = _.orderBy(
                productionData,
                [sortColumn.path],
                [sortColumn.order]
            );
            setProductionData(sorted)
            setSortColumn(sortColumn)
        }
    }

    const setSelection = (key, option, equips) => {
        if (key == 'EquipmentGroup') {
            SetEquips(equips ? equips : []);
            setSelectedEquipGroupOption(option)
        }
        if (key == 'Equipment') {

            setSelectedEquipOption(option)
        }
    }

    const gettAnalysisFilterData = (data) => {
        data = _.cloneDeep(cacheData)
        if (data.length > 0) {
            let equips = [...selectedEquipOption1]
            if (inputData2.Periodicity && inputData2.From && inputData2.Till && shiftOption1.some(a => a.checked) && equips.length > 0) {
                data = data.filter((object) => {
                    if (equips.some(a => a.label == object.Equipment)) {
                        return object
                    }
                })
                data = data.filter((object) => {
                    let oldFrom1 = new Date(inputData2.From);
                    oldFrom1.setHours(0, 0, 0, 0);
                    let oldTill1 = new Date(inputData2.Till);
                    oldTill1.setHours(23, 59, 59, 999)
                    if ((oldFrom1 <= new Date(object.From)) && (new Date(object.Till) <= oldTill1)) {
                        return object
                    }
                })
                data = data.filter((object) => {
                    if (shiftOption1.some(a => a.checked && object.Shift == a.value)) {
                        return object;
                    }
                })
                return data;
            } else {
                return []
            }
        }

        return data
    }

    const onApply = () => {
        let obj = { ...inputData1 };
        setInputData2(obj);
    }


    return (
        <div className="phase1-detailed-production-page d-flex flex-column" style={{ minHeight: '93vh', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", background: '#f4f6f9', paddingBottom: 20 }}>
            <style>{`
                .phase1-detailed-production-page .report-filter-card label { color: #5a6a85; font-size: 11px; font-weight: 600; letter-spacing: .4px; text-transform: uppercase; }
                .phase1-detailed-production-page .report-action-row { display: flex !important; flex-wrap: wrap !important; align-items: center !important; gap: 12px !important; min-height: 48px !important; margin: 0 !important; padding: 4px 0 !important; max-width: 100%; box-sizing: border-box; justify-content: flex-end; align-self: flex-end; }
                .phase1-detailed-production-page .report-action { display: inline-flex !important; align-items: center !important; justify-content: center !important; box-sizing: border-box; min-width: 96px; min-height: 36px !important; margin: 0 !important; border: 1px solid transparent !important; border-radius: 6px; padding: 8px 18px !important; color: #fff !important; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px; font-weight: 600; line-height: 18px; text-decoration: none !important; white-space: nowrap; cursor: pointer; transition: transform .15s ease, box-shadow .15s ease, opacity .15s ease; }
                .phase1-detailed-production-page .report-action-excel,
                .phase1-detailed-production-page .report-action-detail,
                .phase1-detailed-production-page .report-action-analysis,
                .phase1-detailed-production-page .report-action-email { min-width: 108px !important; }
                .phase1-detailed-production-page .report-action-neutral { min-width: 84px !important; }
                .phase1-detailed-production-page .report-action:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 4px 10px rgba(15,32,39,.18); }
                .phase1-detailed-production-page .report-action:focus-visible { outline: 2px solid #93c5fd; outline-offset: 2px; }
                .phase1-detailed-production-page .report-action:disabled,
                .phase1-detailed-production-page .report-action[aria-disabled='true'] { cursor: not-allowed; opacity: .55; transform: none; box-shadow: none; }
                .phase1-detailed-production-page .report-action-row > p { display: none; margin: 0 !important; padding: 0 !important; }
                .phase1-detailed-production-page .report-action-primary { background: linear-gradient(135deg, #0f2027, #2c5364) !important; box-shadow: 0 2px 6px rgba(15,32,39,.25); }
                .phase1-detailed-production-page .report-action-excel { background: linear-gradient(135deg, #198754, #20c997) !important; box-shadow: 0 2px 6px rgba(25,135,84,.25); }
                .phase1-detailed-production-page .report-action-detail { background: linear-gradient(135deg, #2563eb, #3b82f6) !important; box-shadow: 0 2px 6px rgba(37,99,235,.2); }
                .phase1-detailed-production-page .report-action-analysis { background: linear-gradient(135deg, #7c3aed, #a855f7) !important; box-shadow: 0 2px 6px rgba(124,58,237,.2); }
                .phase1-detailed-production-page .report-action-email { background: linear-gradient(135deg, #2563eb, #3b82f6) !important; box-shadow: 0 2px 6px rgba(37,99,235,.2); }
                .phase1-detailed-production-page .report-action-neutral { background: #fff !important; border-color: #94a3b8 !important; color: #334155 !important; }
                .phase1-detailed-production-page .report-table-surface { background: #fff; border: 1px solid #e0e6ed; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,.06); overflow: auto; }
                .phase1-detailed-production-page .report-table-surface table { margin-bottom: 0; font-size: 13px; background: #fff; }
                .phase1-detailed-production-page .report-table-surface thead tr { background: linear-gradient(135deg, #0f2027, #2c5364) !important; color: #fff; }
                .phase1-detailed-production-page .report-table-surface thead th { border: 0; padding: 8px 7px; font-size: 11px; white-space: normal; word-break: break-word; line-height: 1.2; }
                .phase1-detailed-production-page .report-table-surface tbody td { padding: 8px 10px; border-color: #f1f5f9; border-bottom: 1px solid #edf1f5; color: #334155; vertical-align: middle; }
                .phase1-detailed-production-page .report-table-surface tbody tr:nth-child(even) { background: #fafbfd; }
            `}</style>
            {querySuccess ? <Loading labelShow={true} label={processEmail?'Please wait while procesing your request':`${index}/${getEquipsForReport().length}`} /> : ''}
            <ReportTitleBanner title="Detailed Production" routeName={["detailed-production1", "DetailedProduction1"]} />
      <ToastContainer/>

            <div className="mx-2 mb-3 p-3 report-filter-card" style={{ background: '#fff', borderRadius: 10, border: '1px solid #e0e6ed', boxShadow: '0 2px 8px rgba(0,0,0,.06)' }}>
            <div className="row align-items-end">
                <EquipmentSelection equipGroups={equipGroups} equip={equip} selectedEquipGroupOption={selectedEquipGroupOption} selectedEquipOption={selectedEquipOption} setSelection={setSelection} />
                <div className="col-sm-2">
                    <div className="form-group text-center">
                        <label className='small'>From</label>
                        <input className={'form-control form-control-sm'} style={{ border: '1px solid #dce1e8', borderRadius: 6, padding: '5px 10px', fontSize: 13, background: '#fafbfc' }} placeholder='dd/mm/yyyy' type='date' onChange={handleOnChange} name='From' value={inputData.From ? new Date(inputData.From).toISOString().split('T')[0] : ''} />
                        {errors.From && <p className='text-danger ' style={{ fontSize: 11 }}>{errors.From}</p>}
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="form-group text-center">
                        <label className='small'>Till</label>
                        <input className='form-control form-control-sm' style={{ border: '1px solid #dce1e8', borderRadius: 6, padding: '5px 10px', fontSize: 13, background: '#fafbfc' }} type='date' placeholder='dd/mm/yyyy' onChange={handleOnChange} name='Till' value={inputData.Till ? new Date(inputData.Till).toISOString().split('T')[0] : ''} />
                        {errors.Till && <p className='text-danger ' style={{ fontSize: 11 }}>{errors.Till}</p>}
                    </div>
                </div>
                {/* <div className="col-sm-2">
          <div className="form-group text-center">
            <label className='small'>Shift</label>
            <select className='form-control form-control-sm' onChange={handleOnChange} name='Shift'>
              <option>--select shift--</option>
              <option>All</option>
              <option>Shift1</option>
              <option>Shift2</option>
              <option>Shift3</option>
            </select>
            {errors.Shift && <p className='text-danger ' style={{ fontSize: 11 }}>{errors.Shift}</p>}
          </div>
        </div> */}
                {/* <div className="col-sm-2">
          <div className="form-group text-center">
            <label className='small'>View Production By</label>
            <select className='form-control form-control-sm' onChange={handleOnChange} name='ViewProductionBy'>
              <option>--view production by</option>
              <option>Component</option>
              <option>Operator</option>
              <option>Machine</option>
            </select>
            {errors.ViewProductionBy && <p className='text-danger ' style={{ fontSize: 11 }}>{errors.ViewProductionBy}</p>}
          </div>
        </div> */}
                <div className="col-sm-4 report-action-row">
                    <button className='report-action report-action-primary' onClick={() => handleOnSubmit(inputData)}>Apply</button>
                    {productionData.length > 0 ? <a className='report-action report-action-excel' onClick={() => handleDownloadTableToExcel('DetailedProduction')}>Download</a> : <p></p>}
                </div>
                {/* <div className="col-sm-1">
                    <button className='report-action report-action-email' onClick={() => handleOnSendEmail(inputData)}>Send Email</button>
                </div> */}
              
               


            </div>
            </div>



            <div>
                {productionData.length > 0 ? <div className="mx-2 mb-3 report-table-surface"><DetailedProductionTable1 id='DetailedProduction' qualityReason={qualityReason} reasons={reasons} data={productionData} /></div> : <div className="mx-2 mb-3 p-4 text-center" style={{ background: '#fff', border: '1px dashed #ced4da', borderRadius: 10, color: '#6c757d' }}>📊<div style={{ marginTop: 8 }}>No data to display. Select filters and click <strong>Apply</strong>.</div></div>}
            </div>
        </div>
    );
}
export default DetailedProduction1;